import type {
  TDateString, TUuid, TUuidObject,
} from './common';
import type { TUserFacilityRelation } from './facilityUserRelation';
import type { TTargetSpeciality } from './targetSpeciality';
import type { TTimePeriod } from './timePeriod';
import type { TUserPlanningGroupPermissionRelation } from './planningGroupUserRelation';
import type { TUserPlanningGroupRelation } from './userPlanningGroupRelation';

export type TPhysicianTargetSpecialityRelation = {
  id: number
  target_speciality_id: TTargetSpeciality
};

// The catalog id as the profile loads it, not the expanded catalog entry.
export type TPhysicianAdditionalTrainingRelation = {
  id: number
  additional_training_id: TUuid
  in_training: boolean
};

export type TPhysicianSubspecialityRelation = {
  id: number
  subspeciality_id: TUuid
  in_training: boolean
};

export type TPhysician = {
  id?: TUuid
  target_speciality: TTargetSpeciality | null
  completed_target_specialities?: TPhysicianTargetSpecialityRelation[]
  additional_trainings?: TPhysicianAdditionalTrainingRelation[]
  subspecialities?: TPhysicianSubspecialityRelation[]
};
export enum ERoleIdentifier {
  ADMIN = 'ADMIN',
  ADMINISTRATIVE_STAFF = 'ADMINISTRATIVE_STAFF',
  ROTATING_STAFF = 'ROTATING_STAFF',
  READ_ONLY = 'READ_ONLY',
}

export enum EUserPosition {
  Stammpersonal = 'Stammpersonal',
  Facharzt = 'Facharzt',
  Chefarzt = 'Chefarzt',
  Oberarzt = 'Oberarzt',
}

export type TUserWithRole = Readonly<{ role?: Readonly<{ identifier?: string | null }> | null }>;

export type TUser = TUserWithRole & {
  avatar: TUuid | null
  email: string | null
  include_in_rotation: boolean
  first_name: string | null
  gender: string | null
  id: TUuid
  last_name: string | null
  position: EUserPosition | null
  start_date: TDateString | null
  title: string | null
  total_added_progress: number | null
  /**
   * The Verbund the user belongs to, and the tenant scope every record they create is stamped
   * with. Optional because a user who has not been assigned one yet carries null.
   */
  main_facility?: TUuidObject | null
  /** Whether the user administers the whole Verbund rather than a single facility. */
  main_facility_admin?: boolean
  facilities: TUserFacilityRelation[]
  physician: TPhysician[]
  time_periods: TTimePeriod[]
  favorite_planning_groups: TUserPlanningGroupRelation[]
  planning_groups: TUserPlanningGroupPermissionRelation[]
};
